module.exports = __webpack_public_path__ + "assets/93278461e398d7d89803ecb53dd02aaf.png";